import cart from '../../api/cart';
import { cancleableRequest } from '../../api/helpers';

const state = {
  items: [],
  totalPrice: {},
  loading: false,
};

const getters = {
  cartCount: state => {
    let totalCount = 0;

    state.items.forEach(item => {
      totalCount += item.quantity;
    });

    return totalCount;
  }
};

const actions = {
  refresh({ commit }, { items, total_price }) {
    commit('CLEAR');

    items.forEach(item => {
      commit('ADD_ITEM', item);
    });

    commit('SET_TOTAL_PRICE', total_price);
  },
  async init({ dispatch, commit }) {
    commit('SET_LOADING', true);

    try {
      let { data } = await cart.all();

      dispatch('refresh', data);
    } catch (e) {
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async add({ dispatch, commit }, payload) {
    commit('SET_LOADING', true);

    try {
      let { data } = await cart.add(payload);

      dispatch('refresh', data);
    } catch (e) {
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async remove({ dispatch, commit }, id) {
    commit('SET_LOADING', true);

    try {
      let { data } = await cart.remove(id);

      dispatch('refresh', data);
    } catch (e) {
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async updateQuantity({ dispatch, commit, state }, { id, quantity }) {
    commit('SET_LOADING', true);

    const cartItem = state.items.find(item => item.id === id);
    const quantityDifference = quantity - cartItem.quantity;
    let apiName = null;

    switch (Math.sign(quantityDifference)) {
      case 1:
        apiName = 'increase';
        break;
      case -1:
        apiName = 'decrease';
        break;
    }

    try {
      const { data } = await cart[apiName]({
        id,
        payload: { quantity: Math.abs(quantityDifference) }
      });

      dispatch('refresh', data);
    } catch (e) {
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }

  }
};

const mutations = {
  CLEAR: (state) => state.items = [],
  ADD_ITEM: (state, data) => state.items.push(data),
  SET_TOTAL_PRICE: (state, data) => state.totalPrice = data,
  SET_LOADING: (state, data) => state.loading = data,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
